module.exports = __webpack_public_path__ + "img/company-team-4.596b8af5.jpg";